/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { formatNumber, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartEvent, ActiveElement, Chart, Scale, Tick } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';
import { VideoModal } from '../../components/VideoModal';
import { DrillDownType } from '../DrillDownType';
import { AIIcon } from '../../components/icons/AIIcon';
import html2canvas from 'html2canvas';
import { AIChartDialog } from '../../components/Dialogs/AIChartDialog';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvValueAxisStyle, rvCategoryAxisStyle, rvTooltipStyle, isChartDataEmpty } from '../chartTheme';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartNotes } from '../ChartNotes';
import { AnimatedNumber } from '../AnimatedNumber';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '350px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }
    }),
);

interface AgedUnbilledFeesChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    infoUrl: string;
}

interface ChartState extends AgedUnbilledFees {
    symbol: string;
    isVideoModalOpen: boolean;
}

export const AgedUnbilledFeesChart: React.FC<AgedUnbilledFeesChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    const [base64Data, setBase64Data] = useState<string | ArrayBuffer | null>(null);
    
    const [isAIDialogOpen, setIsAIDialogOpen] = useState<boolean>(false);

    const [isBlobGenerating, setIsBlobGenerating] = useState<boolean>(false);

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    const chartName = 'Total Unbilled Fees';

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    const totalDebtOwingQuery = useQuery<AgedUnbilledFeesData, AgedUnbilledFeesDataParams>(AgedUnbilledFeesDataQuery, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        }
    });
    
    const [state, setState] = useState<ChartState>({
        total: 0,
        symbol: '$',
        current: 0,
        ninetyDays: 0,
        sixtyDays: 0,
        thirtyDays: 0,
        isVideoModalOpen: false
    });

    useEffect(() => {
        if (totalDebtOwingQuery.data && totalDebtOwingQuery.data.statistics && !totalDebtOwingQuery.loading && !totalDebtOwingQuery.error) {
            setState((prevState) => {
              
                const { total, current, ninetyDays, sixtyDays, thirtyDays } = totalDebtOwingQuery.data!.statistics.matter.agedUnbilledFees;

                return {
                    ...prevState,
                    total,
                    current,
                    ninetyDays,
                    sixtyDays,
                    thirtyDays
                };
            });
        }

        // tslint:disable-next-line: align
    }, [totalDebtOwingQuery.loading, totalDebtOwingQuery.error, totalDebtOwingQuery.data]);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            return props.onCloseChart(`isAgedUnbilledFeesChartOpen`);
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize();
        }
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Total Debt Owing - Pie Chart'));
            // tslint:disable-next-line: align
        }, 500);
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onAIGeneratedSuggestion = async (event: any) => {

        setIsBlobGenerating(true);

        event.preventDefault();
        event.stopPropagation();
       
        if (entireChartRef && entireChartRef.current) {
            const canvas = await html2canvas(entireChartRef.current);
            canvas.toBlob((blob) => {
                if (blob) {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = async () => {
                        const tempBase64data = reader.result;
                        // console.log(tempBase64data); // This is your image blob string
                        setBase64Data(tempBase64data);
                        setIsAIDialogOpen(true);
                    };
                }
            });
        }

        setIsBlobGenerating(false);
    };

    const chartControllerComponent = () => {
        return (
            <>
<IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.isAIFeatureEnabled && (
                        <MTooltip title="AI Assistant">
                            <IconButton 
                                disabled={isBlobGenerating}
                                size={props.showAllRecords ? 'medium' : 'small'}
                                onClick={onAIGeneratedSuggestion}
                            >
                                <AIIcon 
                                    color="primary"
                                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                                />
                            </IconButton>
                        </MTooltip>
                    )}
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {

            const searchCriterias = new Array<SearchCriteria>();  

            searchCriterias.push(
                { property: 'TotalWIPBalanceExTax', operator: 'not', comparison: '0' },
                { property: 'TotalWIPBalanceExTax', operator: 'isnot', comparison: 'null' }
            );

            props.getSelectedItem(
                searchCriterias,
                false,
                'Total Unbilled Fees',
                DrillDownType.matterSummaryDrilldown,
                'Unbilled Fees'
            );
        }        
    };

    const onToggleVideo = () => {
        setState((prevState) => {
            return {
                ...prevState,
                isVideoModalOpen: !prevState.isVideoModalOpen
            };
        });
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (totalDebtOwingQuery.loading || currencySymbolQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    return (
        <>
            {isAIDialogOpen && (
                <AIChartDialog 
                    fullWidth={true}
                    maxWidth="md"
                    open={isAIDialogOpen}
                    onClose={() => setIsAIDialogOpen(false)}
                    data={base64Data}
                    query={props.aiPrompt || 'Give me recommendations on this and highlight any exceptions or concerns'}
                    accessSubType={chartName}
                    layoutId={props.layoutId}
                />
            )}
            {state.isVideoModalOpen && props.infoUrl && <VideoModal open={state.isVideoModalOpen} onClose={onToggleVideo} url={props.infoUrl} />}
            <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty([state.current, state.thirtyDays, state.sixtyDays, state.ninetyDays]) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
                {chartControllerComponent()}
                <div className={classes.titleContainer}>
                    <ChartHeading icon={<HourglassEmptyOutlinedIcon />} title={chartName} />
                    <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                        <AnimatedNumber value={state.total} format={(amount) => `${state.symbol}${formatNumber(amount)}`} />
                    </div>
                </div>
                <div className={classes.barContainer}>
                    <Bar
                        ref={chartRef}
                        // tslint:disable-next-line: no-any
                        onClick={(event: React.MouseEvent<any>) => {
                            const _data = getElementAtEvent(chartRef.current, event);
                            if (_data.length > 0 && props.getSelectedItem) {

                                const _index = getElementAtEvent(chartRef.current, event)[0].index;

                                const item = ['Current', '30 days', '60 days', '90 days'][_index];

                                let property = '';
                                if (item === 'Current') {
                                    property = 'CurrentWIPBalanceExTax';
                                } else if (item === '30 days') {
                                    property = 'ThirtyWIPBalanceExTax';
                                } else if (item === '60 days') {
                                    property = 'SixtyWIPBalanceExTax';
                                } else if (item === '90 days') {
                                    property = 'NinetyWIPBalanceExTax';
                                }

                                const searchCriterias = new Array<SearchCriteria>();

                                searchCriterias.push(
                                    { property: property, operator: 'not', comparison: '0' },
                                    { property: property, operator: 'isnot', comparison: 'null' },
                                    { property: 'TotalWIPBalanceExTax', operator: 'isnot', comparison: 'null' },
                                    { property: 'TotalWIPBalanceExTax', operator: 'not', comparison: '0' },
                                );

                                props.getSelectedItem(
                                    searchCriterias,
                                    true,
                                    `Total Unbilled Fees - ${item}`,
                                    DrillDownType.matterSummaryDrilldown,
                                    'Unbilled Fees'
                                );
                            }
                        }}
                        data={{
                            labels: ['Current', '30 days', '60 days', '90 days'],
                            datasets: [
                                {
                                    label: 'Unbilled Fees',
                                    ...rvBarDatasetStyle([RV_CHART_COLORS.primarySoft, RV_CHART_COLORS.primary, RV_CHART_COLORS.amber, RV_CHART_COLORS.red]),
                                    data: [state.current, state.thirtyDays, state.sixtyDays, state.ninetyDays]
                                }
                            ]
                        }} 
                        options={{
                            onHover: onHover,
                            indexAxis: 'y' as const,
                            animation: rvChartAnimation(),
                            elements: { bar: { borderWidth: 0 } },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick([state.current, state.thirtyDays, state.sixtyDays, state.ninetyDays]),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit([state.current, state.thirtyDays, state.sixtyDays, state.ninetyDays]),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${state.symbol}${formatNumber(tickValue)}`;
                                    }
                                }
                                },
                                y: {
                                    grid: rvCategoryAxisStyle.grid,
                                // min: 0,
                                // max: 9 // minimum display
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false
                                }
                                }
                            },
                            plugins: {
                                legend: {
                                position: 'bottom' as const,
                                display: false
                                },
                                title: {
                                display: false,
                                text: ``,
                                },
                                zoom: {
                                pan: {
                                    enabled: false,
                                    onPan: onPan
                                },
                                zoom: {
                                    wheel: {
                                    enabled: false
                                    }
                                }
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                                },
                                tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const { 
                                        dataIndex, 
                                        //   label, 
                                        //   formattedValue,
                                        //   dataset 
                                        } = context;

                                        var currentValue = [state.current, state.thirtyDays, state.sixtyDays, state.ninetyDays][dataIndex];

                                        return `${state.symbol}${formatNumber(currentValue)}`;
                                    },
                                }
                                }
                            },
                        }}
                    />
                    {isChartDataEmpty([state.current, state.thirtyDays, state.sixtyDays, state.ninetyDays]) && (
                        <ChartEmptyState title="No unbilled fees" hint={"Nothing is unbilled right now."} />
                    )}
                </div>
                <ChartNotes
                    notes={['Fees only, disbursement are not included', 'Information collated by Matter Responsibility']}
                    actionHint="Drill down to matters"
                />
            </div>
        </>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export type AgedUnbilledFeesDataParams = {
    entityType?: number;
    entityGuid?: string, 
    responsibility?: number, 
    showAllRecords?: boolean
};

export type AgedUnbilledFeesData = {
    statistics: Statistics;
};

export type Data = {
    statistics: Statistics;
}

export type Statistics = {
    matter: Matter;
}

export type Matter = {
    agedUnbilledFees: AgedUnbilledFees;
}

export type AgedUnbilledFees = {
    total:      number;
    current:    number;
    thirtyDays: number;
    sixtyDays:  number;
    ninetyDays: number;
}

const AgedUnbilledFeesDataQuery = gql`
    query AgedUnbilledFeesData ($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics{
            matter{
                agedUnbilledFees(
                        entityType: $entityType, 
                        entityGuid: $entityGuid, 
                        responsibility: $responsibility
                ){
                    total,
                    current,
                    thirtyDays,
                    sixtyDays,
                    ninetyDays
                }
            }
        }
    }
`;
